import React from 'react';
import ForeignAssetsHome from './assetsHome';
import AssetsAccordin from './assetsAccordin';

export default function ForeignAssets() {

    return (
        <div>
           <ForeignAssetsHome /> 
           <AssetsAccordin />
        </div>
    );
}
